import { TrademarkOffice } from "app/models/trademark.model";

export const trademarkImageUrl = (id: string, office: TrademarkOffice, thumbnail?: boolean) => {
  const shard = id.slice(-2);
  const maybeThumbnailSuffix = thumbnail ? "-thumbnail" : "";
  return `https://oktomark.s3.eu-central-1.amazonaws.com/${office.toLowerCase()}/cache/images/${shard}/${id}${maybeThumbnailSuffix}.webp`;
};
